import { render, staticRenderFns } from "./CT.vue?vue&type=template&id=35cf1e24&scoped=true&"
var script = {}
import style0 from "./CT.vue?vue&type=style&index=0&id=35cf1e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf1e24",
  null
  
)

export default component.exports